import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=adc3198a&scoped=true&"
import script from "./CourseCard.vue?vue&type=script&lang=ts&"
export * from "./CourseCard.vue?vue&type=script&lang=ts&"
import style0 from "./CourseCard.vue?vue&type=style&index=0&id=adc3198a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc3198a",
  null
  
)

export default component.exports